// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"MerchCardList_cardWrapper__M2PHL"};